import { css } from '@emotion/css';

export const headerStyles = css`
  background: var(--bg-secondary);
  box-shadow: none;
  border: none;
`;

export const breadcrumbLabel = css`
  max-width: 27rem;
`;
